"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const utils_1 = require("@osmosys/utils");
const Sentry = tslib_1.__importStar(require("@sentry/browser"));
const react_1 = tslib_1.__importStar(require("react"));
const react_if_1 = require("react-if");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../context");
const CenteredRow_1 = require("./reusables/CenteredRow");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const react_2 = require("@osmosys/react");
const logger = utils_1.createOsmosysLogger({
    fn: 'ErrorBoundary',
});
class ErrorBoundary extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            clicksOnTextarea: 0,
            copied: false,
            error: undefined,
            errorInfo: undefined,
            eventId: undefined,
            isOpen: false,
        };
        this.componentDidCatch = (error, errorInfo) => {
            console.error(error);
            this.setState({
                clicksOnTextarea: 0,
                error,
                errorInfo,
                eventId: `event- ${new Date().getTime()}`,
                isOpen: true,
            }, () => {
                Sentry.withScope(scope => {
                    scope.setExtra('componentStack', errorInfo.componentStack);
                    const eventId = Sentry.captureException(error);
                    logger.warn(`Error sent to Sentry | Event ID: ${eventId}`);
                    this.setState({
                        eventId,
                    });
                });
            });
        };
    }
    render() {
        return (react_1.default.createElement(exports.ErrorBoundaryInner, { state: this.state, setState: s => this.setState(Object.assign(Object.assign({}, this.state), s)) }, this.props.children));
    }
}
exports.ErrorBoundary = ErrorBoundary;
exports.ErrorBoundaryInner = ({ children, state, setState, }) => {
    const { history } = use_react_router_1.default();
    const textarea = react_1.useRef();
    react_1.useEffect(() => {
        if (state.isOpen) {
            const unlisten = history.listen((location, action) => {
                logger.info({ action, location });
                setState({
                    clicksOnTextarea: 0,
                    error: undefined,
                    isOpen: false,
                });
            });
            return () => {
                unlisten();
            };
        }
        else {
            return () => { };
        }
    }, [history, setState, state.isOpen]);
    const getErrorText = () => {
        var _a;
        const extraInfo = Object.assign({}, state.errorInfo);
        let componentStack;
        if ((_a = extraInfo) === null || _a === void 0 ? void 0 : _a.componentStack) {
            componentStack = extraInfo.componentStack;
            delete extraInfo.componentStack;
        }
        const clean = (str) => {
            return str
                .trim()
                .replace(/\\t/gm, '  ')
                .replace(/\\n/gm, '\n\t\t');
        };
        const hasExtraInfo = extraInfo && Object.keys(extraInfo) && Object.keys(extraInfo).length > 0;
        return `Event identifier:
      ${state.eventId}

Location:
    ${window.location.href}

Stack Trace:
    ${state.error ? clean(state.error.stack) : 'No stack trace'}

Component Stack:
    ${componentStack ? clean(componentStack) : 'No component stack'}

${hasExtraInfo
            ? `Extra Info:
    ${hasExtraInfo ? JSON.stringify(extraInfo) : 'N/A'}`
            : ''}
`;
    };
    const errorText = state.error && getErrorText();
    return (react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ currentUser }) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_2.OsmosysModal, { osysName: "ErrorBoundary", isOpen: state.isOpen, centered: true, size: "lg" }, state.error && (react_1.default.createElement(reactstrap_1.ModalBody, { className: "text-center" },
                react_1.default.createElement("h1", { className: "text-danger" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle })),
                react_1.default.createElement("h3", null, "Something went wrong"),
                react_1.default.createElement("p", { className: "lead" }, "There was an error that caused Osmosys to stop working."),
                react_1.default.createElement(react_if_1.If, { condition: errorText && errorText.includes('ChunkLoadError') },
                    react_1.default.createElement(react_if_1.Then, null,
                        react_1.default.createElement(reactstrap_1.Alert, { color: "warning", className: "border-0 bg-transparent" },
                            react_1.default.createElement(CenteredRow_1.CenteredRow, { className: "my-3 justify-content-center" },
                                "[",
                                react_1.default.createElement("div", { className: "p-2" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGlobeAmericas, size: "lg" })),
                                ",",
                                react_1.default.createElement("div", { className: "px-2" },
                                    react_1.default.createElement("p", { className: "mb-0" }, "Could not load Osmosys. Are you connected to the internet?")),
                                "]"))),
                    react_1.default.createElement(react_if_1.Else, null,
                        react_1.default.createElement("textarea", { style: {
                                borderColor: '#eee',
                                color: '#555',
                                fontFamily: 'Courier New',
                                fontSize: 12,
                                height: 280,
                                outline: 0,
                            }, ref: textarea, onClick: () => {
                                if (state.clicksOnTextarea === 0) {
                                    textarea.current.select();
                                }
                                setState({
                                    clicksOnTextarea: 1 + state.clicksOnTextarea,
                                });
                            }, className: "w-100 border-1 p-2 bg-transparent", value: errorText, readOnly: true }))),
                react_1.default.createElement("div", { className: "flex-full-row-centered" },
                    react_1.default.createElement(reactstrap_1.ButtonGroup, { className: "justify-content-center mb-2", alt: "Go Back" },
                        react_1.default.createElement(react_2.OsmosysButton, { osysName: "errorBoundary.goBack", 
                            // faIcon={faArrowLeft}
                            osysIcon: "arrowLeft", color: "link", onClick: () => history.goBack() }, "Go Back"),
                        location.pathname.replace('/', '') !== '' && (react_1.default.createElement(react_2.OsmosysButton, { osysIcon: "home", color: "link", osysName: "errorBoundary.goHome", to: "/" }, "Go Home")),
                        react_1.default.createElement(react_2.OsmosysButton
                        // faIcon={faRedoAlt}
                        , { 
                            // faIcon={faRedoAlt}
                            osysIcon: "reload", color: "link", onClick: () => window.location.reload(), osysName: "errorBoundary.reload" }, "Reload Page"))),
                react_1.default.createElement("div", { className: "mt-2" },
                    react_1.default.createElement(react_2.OsmosysButton, { color: "primary", osysName: "ErrorBoundary.submitReport", osysIcon: "arrowRight", iconPosition: "right", onClick: () => {
                            var _a, _b;
                            Sentry.showReportDialog({
                                eventId: state.eventId,
                                labelSubmit: 'Submit report',
                                subtitle: 'Yellow Brim support has been notified.',
                                user: {
                                    email: (_a = currentUser) === null || _a === void 0 ? void 0 : _a.email,
                                    name: (_b = currentUser) === null || _b === void 0 ? void 0 : _b.fullName,
                                },
                            });
                            setState({
                                isOpen: false,
                            });
                        } }, "Report error")),
                react_1.default.createElement("div", { className: "text-center text-muted small mt-2" },
                    react_1.default.createElement("a", { className: "text-reset", href: "mailto:support@yellowbrim.com", target: "_blank", rel: "noopener noreferrer" }, "support@yellowbrim.com"))))),
            !state.error && children));
    }));
};
//# sourceMappingURL=ErrorBoundary.js.map